import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const RequestStateMap: Record<string, { headline: string; subtitle: string }> = {
  DEFAULT: {
    headline: 'cartridge.contactRequest.dialog.headline.default',
    subtitle: 'cartridge.contactRequest.dialog.subtitle.default',
  },
  ERROR: {
    headline: 'cartridge.contactRequest.dialog.headline.error',
    subtitle: 'cartridge.contactRequest.dialog.subtitle.error',
  },
  SUCCESS: {
    headline: 'cartridge.contactRequest.dialog.headline.success',
    subtitle: 'cartridge.contactRequest.dialog.subtitle.success',
  },
};

enum ContactRequestStatus {
  DEFAULT = 'DEFAULT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

@Component({
  selector: 'markant-platform-contact-request-dialog',
  templateUrl: './contact-request-dialog.component.html',
  styleUrls: ['./contact-request-dialog.component.scss'],
})
export class ContactRequestDialogComponent implements OnInit {
  requestStateMap = RequestStateMap;
  requestStates = ContactRequestStatus;
  currentRequestState = signal(ContactRequestStatus.DEFAULT);
  isRequestLoading = false;

  @Input() open = false;
  @Input() requestStateOnSubmit = new Subject<boolean>();
  @Output() openChange = new EventEmitter<boolean>();
  @Output() isApproved = new EventEmitter<boolean>();

  constructor(private readonly destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.requestStateOnSubmit.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.currentRequestState.set(res ? ContactRequestStatus.SUCCESS : ContactRequestStatus.ERROR);
      this.isRequestLoading = false;
    });
  }

  closeDialog(): void {
    this.open = false;
    this.isRequestLoading = false;
    this.currentRequestState.set(ContactRequestStatus.DEFAULT);
    this.openChange.emit(false);
  }

  approve(): void {
    this.isRequestLoading = true;
    this.isApproved.emit(true);
  }
}
